import { cronosClient } from "@/config/client"

export type MilestoneType = "exam" | "reminder"

export interface Milestone {
  id: string
  title: string
  courseId: string
  dateTime: number
  type: MilestoneType
  modules: MilestoneModule[]
}

export interface MilestoneModule {
  id: string
  name: string
  progress: number
  units: MilestoneUnit[]
}

export interface MilestoneUnit {
  id: string
  name: string
}

interface GetMilestonesResponse {
  description: Milestone[]
}

interface GetMilestonesPayload {
  subjectId: string
  courseId?: string
}

export function get(params: GetMilestonesPayload) {
  return cronosClient.get<GetMilestonesResponse>(`/v1/milestones`, { params })
}
